/**
 * Кое от опашката да тръгне сега. Събитие, което още чака координатата си
 * (първи опит, отсрочено до 15 с), задържа събитията след него — сървърът ги
 * получава по реда на натискане, не по реда, в който GPS-ът е отговорил.
 * Повторните опити след грешка не задържат нищо, иначе едно счупено събитие
 * би спряло всички след него.
 */
export interface OrderableItem {
  kind: string;
  createdAt: number;
  attempts: number;
  nextAttemptAt: number;
}

export function readyToSend<T extends OrderableItem>(pending: readonly T[], now: number): T[] {
  const waitingForFix = pending
    .filter((item) => item.kind === 'event' && item.attempts === 0 && item.nextAttemptAt > now)
    .map((item) => item.createdAt);
  const holdEventsFrom = waitingForFix.length ? Math.min(...waitingForFix) : Infinity;
  return pending
    .filter((item) => item.nextAttemptAt <= now)
    .filter((item) => !(item.kind === 'event' && item.createdAt > holdEventsFrom))
    .sort((a, b) => a.createdAt - b.createdAt);
}
